import { Trans, useTranslation } from "react-i18next";
import {
  Box,
  Divider,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useMandatorContext } from "@rentablo/theming";
import { TermsLinkStyled } from "@components";

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.secondary}`,
  boxShadow: theme.shadows[2],
  borderRadius: "12px",
  padding: theme.spacing(5, 6, 5, 6),
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(5, 3, 5, 3),
  },
}));

export const ImpressumCard = ({ namespace }: { namespace: string }) => {
  const { t } = useTranslation("translation", {
    keyPrefix: namespace,
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { isRentablo } = useMandatorContext();
  const supportEmail = isRentablo ? "info@rentablo.de" : "info@wealthapi.eu";

  return (
    <Card mt={8} mb={14}>
      <Typography
        variant={isMobile ? "subtitle1" : "h6"}
        fontWeight="600"
        color={theme.palette.text.tertiary}
      >
        {t("title")}
      </Typography>
      <Typography variant="h4" mt={1}>
        {t("card.title")}
      </Typography>
      <Typography
        variant="subtitle1"
        my={6}
        whiteSpace="pre-line"
        color="textSecondary"
      >
        <Trans i18nKey={`${namespace}.card.address`}>
          {[
            <Typography
              key="subtitle"
              variant="subtitle1"
              color="textPrimary"
              component="span"
            />,
          ]}
        </Trans>
      </Typography>
      <Typography my={6} whiteSpace="pre-line">
        <Trans i18nKey={`${namespace}.card.contacts`}>
          {[
            <TermsLinkStyled
              key="phone"
              href={`tel:${
                isRentablo ? "(0) 30 - 71 53 30 09" : "(0) 30 - 57 71 49 38"
              }`}
            />,
            <TermsLinkStyled key="email" href={`mailto:${supportEmail}`} />,
            <TermsLinkStyled
              key="web"
              href={
                isRentablo
                  ? "https://www.rentablo.de"
                  : "https://www.wealthapi.eu"
              }
              target="_blank"
              rel="noreferrer"
            />,
          ]}
        </Trans>
      </Typography>
      <Typography color="textSecondary" my={6} whiteSpace="pre-line">
        {t("card.inn")}
      </Typography>
      <Divider />
      <Typography color="textSecondary" mt={6} whiteSpace="pre-line">
        <Trans i18nKey={`${namespace}.card.bottom`}>
          {[<Typography key="subtitle" color="textPrimary" component="span" />]}
        </Trans>
      </Typography>
    </Card>
  );
};
